import { SEQUENCE_SCHEMA_VERSION, type SequenceDocument, type SequenceEvent, type Track, type TrackType } from '../format/types';

let counter = 0;
export function createId(prefix: string): string {
  counter += 1;
  return `${prefix}-${Date.now().toString(36)}-${counter}`;
}

export function createTrack(overrides: Partial<Track> = {}): Track {
  return {
    id: overrides.id ?? createId('track'),
    name: overrides.name ?? 'Neue Spur',
    role: overrides.role ?? 'lead',
    type: overrides.type ?? 'note',
    mute: overrides.mute ?? false,
    solo: overrides.solo ?? false,
    level: overrides.level ?? 1,
  };
}

export function defaultEventForTrackType(type: TrackType, trackId: string, step: number): SequenceEvent {
  const id = createId('evt');
  switch (type) {
    case 'note':
      return { id, step, trackId, kind: 'note', note: 60, velocity: 100, gate: 1 };
    case 'chord':
      return { id, step, trackId, kind: 'chord', degree: 1, quality: 'major', velocity: 100, gate: 1 };
    case 'drum':
      return { id, step, trackId, kind: 'drum', triggerId: 'kick', velocity: 100 };
    case 'control':
      return { id, step, trackId, kind: 'control', controlId: 'level', value: 0.75 };
  }
}

export function createEmptySequence(name = 'Neue Sequenz'): SequenceDocument {
  const chord = createTrack({ name: 'Chord', role: 'chord', type: 'chord' });
  const bass = createTrack({ name: 'Bass', role: 'bass', type: 'note' });
  const lead = createTrack({ name: 'Lead', role: 'lead', type: 'note' });
  const drums = createTrack({ name: 'Drums', role: 'drums', type: 'drum' });
  return {
    schemaVersion: SEQUENCE_SCHEMA_VERSION,
    id: createId('seq'),
    name,
    version: '0.1.0',
    timing: {
      bpm: 120,
      timeSignature: { numerator: 4, denominator: 4 },
      stepsPerBeat: 4,
      lengthSteps: 16,
      loop: true,
    },
    tracks: [chord, bass, lead, drums],
    events: [],
  };
}
